import BlobImage from 'components/blobImage';
import NoResults from 'components/general/noResults';
import { e4Format, e4Formats } from 'helpers/dates';
import { ArrayHelpers, Copy, Loading, StringHelpers, SystemText } from 'e4shared';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { apiGet } from 'services';
import CompetencyList from '../competencyList';

export const BlogPosts = ({ profileId, range, offset, hideSummary, history, type }) => {
    const [posts, setPosts] = React.useState([]);
    const [index, setIndex] = React.useState(0);
    const [loading, setLoading] = React.useState(true);

    const { user } = useSelector(state => state.user);

    React.useEffect(() => {
        setLoading(true);
        apiGet(`profile/${profileId}/posts?all=1&offset=${offset}&range=${range}&type=${type}`, user.guid, response => {
            setPosts(response.posts);
            setLoading(false);
        });
    }, [profileId, range, offset]);

    if (loading) return <Loading />;

    const setPost = dir => {
        let newIndex = index + dir;
        newIndex = newIndex < 0 ? posts?.length - 1 : newIndex;
        newIndex = newIndex > posts?.length - 1 ? 0 : newIndex;
        setIndex(newIndex);
    };

    if (!posts || posts.length < index + 1)
        return (
            <NoResults
                title={SystemText('General/BlogPosts/NoResults/Title')}
                message={SystemText('General/BlogPosts/NoResults/Message')}
            />
        );
    const post = posts[index];

    return (
        <span className="blog-post-summary" data-testid="121-blogposts-wrapper-testid">
            {hideSummary ? null : (
                <p className="post-summary-viewing">
                    {SystemText(
                        'General/BlogPosts/Paragraph/Summary',
                        `${index + 1} / ${posts.length} ${StringHelpers.pluralise('post', posts.length)}`
                    )}
                </p>
            )}
            <h2 className="pointer" onClick={() => history.push(`/blog/post/${post.id}`)}>
                {post.title}
            </h2>
            <p className="flex flex-center">
                <button
                    data-testid="121-blogposts-viewprevious-button-testid"
                    id="view-prev-button"
                    title={SystemText('General/BlogPosts/Buttons/Title/ViewPrevious')}
                    className="btn btn-xs"
                    disabled={posts.length === 1 || index === 0}
                    onClick={() => setPost(-1)}
                >
                    <i className="fa fa-arrow-left" />
                </button>
                <span className="mr10 ml10">{e4Format(post.date, e4Formats.longWithDay)}</span>
                <button
                    data-testid="121-blogposts-viewnext-button-testid"
                    id="view-next-button"
                    title={SystemText('General/BlogPosts/Buttons/Title/ViewNext')}
                    className="btn btn-xs"
                    disabled={posts.length === 1 || index === posts.length - 1}
                    onClick={() => setPost(1)}
                >
                    <i className="fa fa-arrow-right" />
                </button>
            </p>
            {ArrayHelpers.existsAndHasLength(post.competencies) && (
                <div data-testid="121-blogposts-competencies-testid" className="mt10 mb10">
                    <CompetencyList competencies={post.competencies} />
                </div>
            )}
            <div className="mb20 blog-image-holder pointer">
                <BlobImage
                    onClick={() => history.push(`/blog/post/${post.id}`)}
                    key={`post_${post.blog_Image}`}
                    alt=""
                    folder="blog_Image"
                    src={post.blog_Image}
                />
            </div>
            <div>
                {`${SystemText('General/BlogPosts/WrittenBy')} `}
                <Link to={`/blog/${post.owner_Id}`}>{post.owner_Full_Name}</Link>
            </div>
            <p className="mt5">
                <Copy value={post.description} />
            </p>
            <p>
                <span className="mr10">
                    <i className="fa fa-comments" /> {post.comment_Count}
                </span>
                <i className="fa fa-thumbs-up" /> {post.like_Count}
            </p>
            <button
                data-testid="121-blogposts-view-button-testid"
                id="view-full-button"
                title={SystemText('General/BlogPosts/Buttons/Title/ViewFull')}
                className="btn btn-block btn-primary"
                onClick={() => history.push(`/blog/post/${post.id}`)}
            >
                {SystemText('General/BlogPosts/Buttons/ViewPrevious')}
            </button>
        </span>
    );
};

export default withRouter(BlogPosts);
